import { Component, OnInit } from '@angular/core';
import { ModalService } from 'projects/app-shared/src/public-api';
import { EcommerceGenericoService } from 'projects/ecommerce-generico/src/public-api';

@Component({
  selector: 'modal-retiro-sucursal',
  templateUrl: './modal-retiro-sucursal.component.html',
  styleUrls: ['./modal-retiro-sucursal.component.scss']
})

export class ModalRetiroSucursalComponent implements OnInit {

  constructor(private modal: ModalService, private genServ : EcommerceGenericoService) { }

  ngOnInit(): void {
  }

  aceptar() {
    this.modal.close('modal-retiro-sucursal');
  }

  get retiroSucursal(){
    return this.genServ.getretiroSucursal()
  }

  get errorMessage() {
    return this.genServ.getErrorMessage();
  }

}
